module.exports = __webpack_public_path__ + "img/star-favorite.f0fb93c7.svg";